export type SessionControllerConfiguration = {
  userId?: string;
  idleTimeBetweenSessions: number;
  timeBetweenUpdates: number;
  debug?: boolean;
};

export type SessionSnapshot = {
  id: string;
  userId?: string;
  initialTimeStamp: number;
  currentInitialTimeStamp: number;
  lastUpdatedTimeStamp: number;
  lastUpdatedById: string;
  timeSpent: number;
  totalTimeSpent: number;
  snapshots?: SessionSnapshot[];
};

export enum SessionEvents {
  START = 'session-start',
  STOP = 'session-stop',
  CREATE = 'session-create',
  UPDATE = 'session-update',
}
